import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useViewer } from '../../context/viewer-context';
export default function View(props) {
    var hasRole = useViewer().hasRole;
    var ok = props.allowedRoles.some(function (role) { return hasRole(role); });
    if (!ok) {
        return null;
    }
    return _jsx(_Fragment, { children: props.children }, void 0);
}
//# sourceMappingURL=View.js.map